module.exports = __webpack_public_path__ + "img/6.9ca35047.jpg";